import { CheckboxGroup as BaseCheckboxGroup } from '@base-ui/react/checkbox-group'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface CheckboxGroupProps extends PartProps<BaseCheckboxGroup.Props> {
  className?: string
}

/**
 * Several checkboxes that answer one question, held as one `string[]` value: each Checkbox inside
 * takes a `value`. Sit it in a `Field` and each option in a `Field.Item`, as with RadioGroup. Pass
 * `allValues` and mark one Checkbox `parent` for a select-all that goes indeterminate on its own.
 *
 * A part, not the root: most checkboxes stand alone as their own yes or no.
 */
function CheckboxGroup({ className, ...props }: CheckboxGroupProps) {
  return <BaseCheckboxGroup className={twMerge('flex flex-col gap-3', className)} {...props} />
}

export { CheckboxGroup }
